<template>
  <div>
    <TopBar />
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-1">
        </div>
        <div class="col-sm-3" style="padding:20px;">
          <MenuSetup />
        </div>
        <div class="col-sm-7">
          <div style="margin-top:30px;">
            <form>
              <div class="form-group row">
                <label for="imgprog" class="col-sm-3 col-form-label aright">{{ $t('programmer') }}</label>
                <div class="col-sm-9">
                  <div class="prog_control" style="padding-top:8px;">
                      <input class="prog_state" type="image" src="https://img.intratone.info/icon/etat/1.png" name="imgprog" id="imgprog" onclick="Prog.information();" style="float:left; margin:0 5px; width:auto;">
                      <img class="prog_type" style="float:left; margin:0 10px; width:auto; margin-left:10px; height:20px;" id="typeprog" src="https://img.intratone.info/Images/Programmateur/prog_usb2.png" onclick="Prog.information();">
                      <div style="clear:both;"></div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="serialgrave" class="col-sm-3 col-form-label aright">{{ $t('serialgrave') }}</label>
                <div class="col-sm-3">
                  <input type="text" class="form-control badgegrave" id="serialgrave" name="serialgrave">
                </div>
              </div>
              <div class="form-group row">
                <label for="imgbadge" class="col-sm-3 col-form-label aright">
                  <input type="image" src="https://img.intratone.info/Images/Cle/CleVierge.png" id="imgcle" class="badgeimg" />
                </label>
                <div class="col-sm-9">
                  <table class="FormCle" style="width:310px; height: 26px; margin-top:4px;" >
                      <tr><td id="c1"></td>
                          <td id="c2"></td>
                      </tr>
                  </table>
                </div>
              </div>
            </form>
            <div class="alert alert-info" style="width: 70%; margin: 20px auto;">
              {{ $t('putFobOnProg') }}
            </div>
          </div>
        </div>
        <div class="col-sm-1">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopBar from './TopBar.vue'
import MenuSetup from './MenuSetup.vue'

export default {
  name: 'Badge',
  components: {
      TopBar,
      MenuSetup
  },
  data: function() {
    return {
      system : false,
      nav : false,
      appli : '',
      prog : false
    }
  },
  created: function () {
    let self = this;
    document.title = this.$i18n.t(`readAnFob`);
    setTimeout(function(){
      self.runReadBadge();
    },300);
  },
  beforeDestroy(){
    Prog.close();
  },
  methods : {
    runReadBadge(){
      //alert('runReadBadge');
      self = this;
      Prog.install();
      Prog.init(function (d) {
          //proglib.badge.lire();
          self.readAnFob();
      });
    },
    readAnFob(){
      self = this;
      Prog.request({'function': 'YATilUneCle'}, function(d) {
          Prog.log('readAnFob', 'd', JSON.stringify(d));
          if (d.Tag != '' && d.Code != '') {
            self.drawAnFob(d);
          }
      });
    },
    drawAnFob(d){
      this.tag = d.Tag;
      this.typ = d.Typ;
      this.code = d.Code;
      this.color = d.Couleur;
      var typeColor = [];
      //typeColor[23] = ['Noire', 'Bleue', 'Verte', 'Rouge', 'Marron', 'Grise', 'Noire Bleue', 'Noire Verte', 'Noire Rouge', 'Noire Grise', 'Jaune', 'Orange', 'Violet', 'Ivoire', 'Grise Bleue', 'Grise Verte', 'Grise Rouge', 'Grise Jaune', 'Rose pailleté', 'Turquoise', 'Bleu Pailleté', 'Vert Pomme', 'Bleu Pailleté ???'];
      if (this.tag == this.lasttag && this.tag != '')
          return;
      if (this.code == '')
          return;
      this.flash = this.tag;
      var src = '';
      switch (parseInt(this.typ, 10)) {
          case 2:
          case 9:
              this.hf = 0;
              code = this.tag;
              src = "/Images/Cle/CleHexact.png";
              break;
          case 4:
          case 41:
          case 17:
              this.hf = 0;
              code = this.tag;
              src = "/Images/Cle/TelHexact.png";
              break;
          case 13:
              this.hf = 0;
              this.code = this.tag;
              src = "/Images/Cle/Vachette.jpg";
              break;
          case 14:
              this.hf = 0;
              code = this.tag;
              src = "/Images/Cle/VachetteDuo.bmp";
              break;
          case 61:
              this.hf = 0;
              src = "/Images/Cle/CleConcurrente.jpg";
              break;
          case 16:
              $('#LesCls').css('display', '');
              if (this.color < 300 || this.color > 310)
                  this.color = -1; // gestion immotec
              this.hf = 0;
              code = this.tag;
              src = "/Images/Cle/CleConcurrente.jpg";
              break;
          case 11:
          case 18:
              this.flash = CompleteStr(parseInt(this.code, 10).toString(16).toUpperCase(), 8, '0', 'l');
              src = "/Images/Cle/CleIntratone.png";
              break;
          case 12:
          case 19:
              this.flash = CompleteStr(parseInt(this.code, 10).toString(16).toUpperCase(), 8, '0', 'l');
              src = "/Images/Cle/telecommande.png";
              $('#lapb').show();
              break;
          case 23:
              this.flash = CompleteStr(parseInt(this.code, 10).toString(16).toUpperCase(), 8, '0', 'l');
              src = "/Images/Cle/clemetal.png";
              break;
          case 24:
              this.flash = CompleteStr(parseInt(this.code, 10).toString(16).toUpperCase(), 8, '0', 'l');
              src = "/Images/Cle/telecommandemetal.png";
              $('#lapb').show();
              break;
          case 27:
              this.flash = CompleteStr(parseInt(this.code, 10).toString(16).toUpperCase(), 8, '0', 'l');
              src = "/Images/Cle/cledad.png";
              $('#lapb').show();
              break;
          case 29:
              this.flash = CompleteStr(parseInt(this.code, 10).toString(16).toUpperCase(), 8, '0', 'l');
              src = "/Images/Cle/telecommandeeco.png";
              $('#lapb').show();
              break;
          case 33:
              src = "/Images/badge/33-23.png";
              $('#lapb').show();
              break;
      }
      if ($('.badgeimg').length)
          $('.badgeimg').attr('src', 'https://img.intratone.info' + src);
      if ($('.badgetag'))
          $('.badgetag').val(this.tag);
      if ($('.badgegrave'))
          $('.badgegrave').val(this.code);
      if ($('.badgeflash')) {
          //var hex = dec2Hex(this.code,8);
          //Prog.log('badgeflash', this.code, this.flash);
          $('.badgeflash').val(this.flash);
      }

      if ($('.badgecolor'))
          $('.badgecolor').val(this.color);
      if ($('.badgetype'))
          $('.badgetype').val(this.typ);
      if ($('.badgehf'))
          $('.badgehf').val(this.hf);
      var nb = 1;
      var c1 = '';
      var c2 = '';
      var cl1 = 'Blanche';
      var cl2 = '';
      switch (parseInt(this.color)) {
          case 0:
              c1 = this.$i18n.t(`black`);
              cl1 = 'Noire';
              break;
          case 1:
              c1 = this.$i18n.t(`blue`); //'lng_Bleue_lng';
              cl1 = 'Bleue';
              break;
          case 2:
              c1 = this.$i18n.t(`green`); //'lng_Verte_lng';
              cl1 = 'Verte';
              break;
          case 3:
              c1 = this.$i18n.t(`red`); //'lng_Rouge_lng';
              cl1 = 'Rouge';
              break;
          case 4:
              c1 = this.$i18n.t(`brown`); //'lng_Marron_lng';
              cl1 = 'Marron';
              break;
          case 5:
              c1 = this.$i18n.t(`grey`); //'lng_Grise_lng';
              cl1 = 'Grise';
              break;
          case 6:
              nb = 2;
              c1 = this.$i18n.t(`black`); //'lng_Noire_lng';
              c2 = this.$i18n.t(`blue`); //'lng_Bleue_lng';
              cl1 = 'Noire';
              cl2 = 'Bleue';
              break;
          case 7:
              nb = 2;
              c1 = this.$i18n.t(`black`);//'lng_Noire_lng';
              c2 = this.$i18n.t(`green`); //'lng_Verte_lng';
              cl1 = 'Noire';
              cl2 = 'Verte';
              break;
          case 8:
              nb = 2;
              c1 = this.$i18n.t(`black`); //'lng_Noire_lng';
              c2 = this.$i18n.t(`red`); //'lng_Rouge_lng';
              cl1 = 'Noire';
              cl2 = 'Rouge';
              break;
          case 9:
              nb = 2;
              c1 = this.$i18n.t(`black`); //'lng_Noire_lng';
              c2 = this.$i18n.t(`grey`); //'lng_Grise_lng';
              cl1 = 'Noire';
              cl2 = 'Grise';
              break;
          case 10:
              c1 = this.$i18n.t(`yellow`); //'lng_Jaune_lng';
              cl1 = 'Jaune';
              break;
          case 11:
              c1 = this.$i18n.t(`orange`); //'lng_Orange_lng';
              cl1 = 'Orange';
              break;
          case 12:
              c1 = this.$i18n.t(`purple`); //'lng_Violet_lng';
              cl1 = 'Violet';
              break;
          case 13:
              if (this.typ == 23) {
                  c1 = this.$i18n.t(`lgbt`); //'lng_Ivoire_lng';
                  cl1 = 'Ivoire';
              } else {
                  nb = 2;
                  c1 = this.$i18n.t(`black`); //'lng_Noire_lng';
                  c2 = this.$i18n.t(`yellow`); //'lng_Jaune_lng';
                  cl1 = 'Noire';
                  cl2 = 'Jaune';
              }
              break;
          case 14:
              nb = 2;
              c1 = this.$i18n.t(`grey`); //'lng_Grise_lng';
              c2 = this.$i18n.t(`blue`); //'lng_Bleue_lng';
              cl1 = 'Grise';
              cl2 = 'Bleue';
              break;
          case 15:
              nb = 2;
              c1 = this.$i18n.t(`grey`); //'lng_Grise_lng';
              c2 = this.$i18n.t(`green`); //'lng_Verte_lng';
              cl1 = 'Grise';
              cl2 = 'Verte';
              break;
          case 16:
              nb = 2;
              c1 = this.$i18n.t(`grey`); //'lng_Grise_lng';
              c2 = this.$i18n.t(`red`); //'lng_Rouge_lng';
              cl1 = 'Grise';
              cl2 = 'Rouge';
              break;
          case 17:
              nb = 2;
              c1 = this.$i18n.t(`grey`); //'lng_Grise_lng';
              c2 = this.$i18n.t(`yellow`); //'lng_Jaune_lng';
              cl1 = 'Grise';
              cl2 = 'Jaune';
              break;
          case 18:
              c1 = this.$i18n.t(`lgbt`); //'lng_Rose pailleté_lng';
              cl1 = 'Pink';
              break;
          case 19:
              //c1='lng_Blanc nacré_lng'; cl1='Nacre';
              c1 = this.$i18n.t(`lgbt`); //'lng_Turquoise_lng';
              cl1 = 'BleueT';
              break;
          case 20:
              c1 = this.$i18n.t(`lgbt`); //'lng_Bleu pailleté_lng';
              cl1 = 'BleueP';
              break;
          case 21:
              c1 = this.$i18n.t(`lgbt`); //'lng_Vert Pomme_lng';
              cl1 = 'VertP';
              break;
          case 22:
              c1 = this.$i18n.t(`lgbt`); //'lng_Bleu pailleté_lng';
              cl1 = 'BleueP';
              break;
              /**
               * 15-06-2009
               * ajout gestion couleur cle
               */
          case 201:
              nb = 1, c1 = this.$i18n.t(`white`); //"lng_Blanc_lng";
              cl1 = "ETCleBlanc";
              break;
          case 202:
              nb = 1, c1 = this.$i18n.t(`blue`); //"lng_Bleue_lng";
              cl1 = "ETCleBleu";
              break;
          case 203:
              nb = 1, c1 = this.$i18n.t(`red`); //"lng_Rouge_lng";
              cl1 = "ETCleRouge";
              break;
          case 204:
              nb = 1, c1 = this.$i18n.t(`green`); //"lng_Vert_lng";
              cl1 = "ETCleVert";
              break;
          case 205:
              nb = 1, c1 = this.$i18n.t(`yellow`); //"lng_Jaune_lng";
              cl1 = "ETCleJaune";
              break;
          case 206:
              nb = 1, c1 = this.$i18n.t(`orange`); //"lng_Orange_lng";
              cl1 = "ETCleOrange";
              break;

              /**
               * 15-06-2009
               * ajout gestion couleur cle
               */

          case 301:
              nb = 1;
              c1 = this.$i18n.t(`blue`); //'lng_Bleue_lng';
              cl1 = 'IBleu';
              break;
          case 302:
              nb = 1;
              c1 = this.$i18n.t(`yellow`); //'lng_Jaune_lng';
              cl1 = 'IJaune';
              break;
          case 303:
              nb = 1;
              c1 = this.$i18n.t(`orange`); //'lng_Orange_lng';
              cl1 = 'IOrange';
              break;
          case 304:
              nb = 1;
              c1 = this.$i18n.t(`red`); //'lng_Rouge_lng';
              cl1 = 'IRouge';
              break;
          case 305:
              nb = 1;
              c1 = this.$i18n.t(`green`); //'lng_Verte_lng';
              cl1 = 'IVerte';
              break;
          case 306:
              nb = 2;
              c1 = this.$i18n.t(`white`); //'lng_Blanche_lng';
              c2 = this.$i18n.t(`blue`); //'lng_Bleue_lng';
              cl1 = 'IBlanc';
              cl2 = 'IBleu';
              break;
          case 307:
              nb = 2;
              c1 = this.$i18n.t(`white`); //'lng_Blanche_lng';
              c2 = this.$i18n.t(`yellow`); //'lng_Jaune_lng';
              cl1 = 'IBlanc';
              cl2 = 'IJaune';
              break;
          case 308:
              nb = 2;
              c1 = this.$i18n.t(`white`); //'lng_Blanche_lng';
              c2 = this.$i18n.t(`orange`); //'lng_Orange_lng';
              cl1 = 'IBlanc';
              cl2 = 'IOrange';
              break;
          case 309:
              nb = 2;
              c1 = this.$i18n.t(`white`); //'lng_Blanche_lng';
              c2 = this.$i18n.t(`red`); //'lng_Rouge_lng';
              cl1 = 'IBlanc';
              cl2 = 'IRouge';
              break;
          case 310:
              nb = 2;
              c1 = this.$i18n.t(`white`); //'lng_Blanche_lng';
              c2 = this.$i18n.t(`green`); //'lng_Verte_lng';
              cl1 = 'IBlanc';
              cl2 = 'IVerte';
              break;
              /** speciel pass concurrent	**/
          case 500:
              nb = 1;
              c1 = this.$i18n.t(`grey`); //'lng_Gris_lng';
              cl1 = 'IGris';
              break;
      }
      c1 = proglib.traduce(c1);
      c2 = proglib.traduce(c2);
      if (this.typ == 23 || this.typ == 24) {
          cl1 = 'M' + cl1;
          if (cl2 != '')
              cl2 = 'M' + cl2;
      }

      if (nb == 1) {
          $('#c2').hide();
          if ($('#c1').length) {
              $('#c1').attr('class', cl1);
              $('#c1').html(c1);
          }
      } else {
          $('#c2').show();
          if ($('#c1').length) {
              $('#c1').attr('class', cl1).html(c1);
              $('#c2').attr('class', cl2).html(c2);
          }
      }
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.aright {
    text-align: right;
}
.steps {
  text-align: left;
  margin:30px;
  font-size: 20px;
  font-weight: bold;
  color: #666;
  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
}
.bimg {
  height: 50px;
}
a:hover h3 {
  color: #043967;
}
.step {
  margin:10px 20px;
}
.stepi {
  height: 24px;
}
a.act {
    margin: 10px auto;
    width: auto;
    padding: 10px;
    display: block;
    color : grey;
    background: #f8f8f8;
    border-radius: 10px;
    text-align: center;
    text-decoration: none;
}
a.act:hover {
    background: #eee;
    color : #08c;
    text-decoration: none;
}
a.act span {
    display: block;
}
a.act img {
    height: 50px;
}
</style>
